namespace $.$$ {
	
	$mol_style_define( $giper_web_frame, {
		
		flex: {
			basis: '4rem',
			shrink: 0,
			grow: 0,
		},
		
	} )
	
}
